module.exports = __webpack_public_path__ + "img/homepage_2.341dd190.png";